export default __webpack_public_path__ + "static/media/products-6.51a76747.webp";